import { render, staticRenderFns } from "./RefTagListAddNew.vue?vue&type=template&id=4cea133e"
import script from "./RefTagListAddNew.vue?vue&type=script&lang=js"
export * from "./RefTagListAddNew.vue?vue&type=script&lang=js"
import style0 from "./RefTagListAddNew.vue?vue&type=style&index=0&id=4cea133e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports